import Chart from 'chart.js';
import counterUp from 'counterup2';

export default {
  init() {
    window.addEventListener('load', () => {
      $('.counter').each(function(index, ele) {
        // const el = document.querySelector('.counter');
        // const el = $(this);

        new window.Waypoint({
          element: $(this),
          handler: function() {
            counterUp(ele, { duration: 2500 });
            this.destroy();
          },
          offset: 'bottom-in-view',
        });
      });
    });

    window.addEventListener('load', () => {
      const bubble = document.getElementById('bubble-chart');
      new Chart(bubble, {
        type: 'bubble',

        data: {
          labels: '솔루션',
          datasets: [
            {
              label: ['고용지원금'],
              backgroundColor: '#483F36',
              borderColor: '#483F36',
              data: [
                {
                  x: 1,
                  y: 80,
                  r: 32,
                },
              ],
            },
            {
              label: ['제도정비'],
              backgroundColor: '#605448',
              borderColor: '#605448',
              data: [
                {
                  x: 2,
                  y: 60,
                  r: 32,
                },
              ],
            },
            {
              label: ['기업인증'],
              backgroundColor: 'rgb(77, 77, 77)',
              borderColor: 'rgb(77, 77, 77)',
              data: [
                {
                  x: 3,
                  y: 50,
                  r: 32,
                },
              ],
            },
            {
              label: ['병역특례'],
              backgroundColor: '#907E6C',
              borderColor: '#907E6C',
              data: [
                {
                  x: 4,
                  y: 10,
                  r: 32,
                },
              ],
            },
            {
              label: ['특허컨설팅'],
              backgroundColor: '#A08C78',
              borderColor: '#A08C78',
              data: [
                {
                  x: 5,
                  y: 20,
                  r: 32,
                },
              ],
            },
            {
              label: ['기업자산관리'],
              backgroundColor: '#BDAFA1',
              borderColor: '#BDAFA1',
              data: [
                {
                  x: 6,
                  y: 70,
                  r: 32,
                },
              ],
            },
            {
              label: ['기업진단'],
              backgroundColor: '#968a7e',
              borderColor: '#968a7e',
              data: [
                {
                  x: 7,
                  y: 60,
                  r: 32,
                },
              ],
            },
            {
              label: ['투자유치/IPO'],
              backgroundColor: '#302A24',
              borderColor: '#302A24',
              data: [
                {
                  x: 7,
                  y: 10,
                  r: 32,
                },
              ],
            },
          ],
        },
        options: {
          responsive: true,
          aspectRatio: 1.33,
          tooltips: {
            enabled: false,
          },
          plugins: {
            datalabels: {
              anchor: function(context) {
                var value = context.dataset.data[context.dataIndex];
                return value.v < 50 ? 'end' : 'center';
              },
              // align: function(context) {
              //   var value = context.dataset.data[context.dataIndex];
              //   return value.v < 50 ? 'end' : 'center';
              // },
              // color: function(context) {
              //   var value = context.dataset.data[context.dataIndex];
              //   return value.v < 50 ? context.dataset.backgroundColor : 'white';
              // },
              color: 'white',
              font: {
                weight: 'bold',
                size: 11,
              },
              formatter: function(value, context) {
                return context.dataset.label[0];
                // return Math.round(value.v);
              },
              offset: 2,
              padding: 0,
            },
          },
          legend: {
            display: false,
          },
          // title: {
          //   display: true,
          //   text: 'Predicted world population (millions) in 2050',
          // },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  max: 110,
                  min: 0,
                  stepSize: 10,
                  callback: function(value) {
                    return value + '%';

                    // return ((value / this.max) * 100).toFixed(0) + '%'; // convert it to percentage
                  },
                },
                scaleLabel: {
                  display: false,
                  // labelString: 'Happiness',
                },
              },
            ],
            xAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  max: 9,
                  min: 0,
                  stepSize: 1,
                },
                scaleLabel: {
                  display: true,
                  labelString: '창업년차',
                  fontSize: 16,
                },
              },
            ],
          },
        },
      });

      const ctx = document.getElementById('case-chart');
      new Chart(ctx, {
        type: 'pie',
        data: {
          labels: [
            '제조',
            '도소매(전자상거래)',
            '정보통신&IT',
            '서비스',
            '건설',
          ],
          datasets: [
            {
              label: '# of Votes',
              data: [18, 24, 22, 34, 2],
              backgroundColor: [
                '#BDAFA1',
                '#A08C78',
                '#907E6C',
                '#605448',
                '#483F36',
              ],
              borderColor: [
                '#BDAFA1',
                '#A08C78',
                '#907E6C',
                '#605448',
                '#483F36',
              ],
              borderWidth: 1,
            },
          ],
        },
        options: {
          layout: {
            padding: 0,
          },
          responsive: true,
          aspectRatio: 1,
          scales: {
            xAxes: [
              {
                display: false,
                gridLines: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                display: false,
                gridLines: {
                  display: false,
                },
              },
            ],
          },
          legend: {
            display: false,
            labels: { padding: 16 },
            position: 'left',
          },
          tooltips: {
            enabled: false,
            // callbacks: {
            //   title: function(tooltipItem, data) {
            //     return data['labels'][tooltipItem[0]['index']];
            //   },
            //   label: function(tooltipItem, data) {
            //     if (tooltipItem['index'] == 0) {
            //       console.log(data);
            //       return '-인테리어 20</br>건축설계 9';
            //     }
            //   },
            // },
            // backgroundColor: '#FFF',
            // titleFontSize: 16,
            // titleFontColor: '#0066ff',
            // bodyFontColor: '#fff',
            // bodyFontSize: 14,
            // displayColors: false,
          },
          plugins: {
            datalabels: {
              // anchor: function(context) {
              //   var value = context.dataset.data[context.dataIndex];
              //   return value.v < 50 ? 'end' : 'center';
              // },
              // align: function(context) {
              //   var value = context.dataset.data[context.dataIndex];
              //   return value.v < 50 ? 'end' : 'center';
              // },
              // color: function(context) {
              //   var value = context.dataset.data[context.dataIndex];
              //   return value.v < 50 ? context.dataset.backgroundColor : 'white';
              // },
              anchor: 'center',
              align: 'center',
              color: 'white',
              textAlign: 'center',
              font: {
                weight: 'bold',
                size: 16,
              },
              formatter: function(value, context) {
                return (
                  context.chart.data.labels[context.dataIndex] +
                  '\n' +
                  Math.round(value) +
                  '%'
                );
                // console.log(value, context);
                // return context.dataset.label[0];
                // return Math.round(value.v);
              },
              offset: 2,
              padding: 0,
            },
            // labels: {
            //   render: function(args) {
            //     console.log(args.label, args.value);
            //     return args.label + ' ' + args.value + '%';
            //   },
            //   fontSize: 16,
            //   fontColor: '#fff',
            //   fontStyle: '500',
            //   fontFamily: 'Noto Sans KR',
            // },
          },
        },
      });
    });
    // JavaScript to be fired on the home page
    $('.testimonials').slick({
      mobileFirst: true,
      // centerMode: true,
      // centerPadding: '16em',
      fade: true,
      // infinite: true,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      dots: false,
      arrows: false,
      prevArrow: '<div class="slick-prev text-center"></div>',
      nextArrow: '<div class="slick-next text-center"></div>',
      responsive: [
        // {
        //   breakpoint: 768,
        //   settings: {
        //     slidesToShow: 3,
        //     slidesToScroll: 1,
        //     infinite: false,
        //   },
        // },
        // {
        //   breakpoint: 991,
        //   settings: {
        //     slidesToShow: 4,
        //     slidesToScroll: 1,
        //     infinite: false,
        //   },
        // },
        // {
        //   breakpoint: 1199,
        //   settings: {
        //     slidesToShow: 4,
        //     slidesToScroll: 2,
        //     infinite: false,
        //   },
        // },
        {
          breakpoint: 1480,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js